/*
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2021-10-20 09:05:40
 * @LastEditors: Jerry
 * @LastEditTime: 2022-06-07 10:27:02
 */
import Vue from 'vue'
import Storage from 'vue-ls'
import App from './App.vue'
import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.css'
import axios from './plugins/axios'
import Auth from './plugins/auth'
import hys from './plugins/utils'
import router from './router'
import store from './store/'
import '../src/assets/common.less'
import lang from './plugins/zh-cn'
import VueBus from 'vue-bus'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './font/iconfont.css'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)
import 'animate.css'
// 引入计算方法
import './plugins/numberExtend.js'
// 2020.12.29
// xuzhongqi
import ElementUI from 'element-ui' // elementUI
import 'element-ui/lib/theme-chalk/index.css' // elementUI样式库
import validation from './utils/validation.js' // 自定义数据验证文件
import comApi from './api/commodity.js' // 公共api文件
Vue.prototype.$validation = validation
Vue.prototype.$comApi = comApi

Vue.config.productionTip = false
Vue.use(Antd)

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Lazyload, { lazyComponent: true })
Vue.use(Storage)
Vue.use(axios)
Vue.use(Auth)
Vue.use(hys)
Vue.use(lang)
Vue.use(VueBus)
Vue.use(ElementUI)
// 全局注入指令
import * as directives from '@/directives'

Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})
// 注册Components
const components = require.context('./components', true, /\.vue$/)
const keys = components.keys()
for (let index = 0; index < keys.length; index++) {
  const k = keys[index]
  const component = components(k).default

  // 去除第一个‘/’和最后的‘.vue’
  const path = k.substring(k.indexOf('/') + 1, k.lastIndexOf('.vue'))
  // 取最后一个‘/’到最后的数据(不包括‘/’)
  const name = path.substring(path.lastIndexOf('/') + 1)

  if (component.name) {
    Vue.component(name, component)
  }
}
Vue.config.devtools = process.env.NODE_ENV === 'development'
new Vue({
  router,
  store,
  locale,
  render: (h) => h(App)
}).$mount('#app')
